import { render, staticRenderFns } from "./caracteristica.vue?vue&type=template&id=4d3077a3"
import script from "./caracteristica.vue?vue&type=script&lang=js"
export * from "./caracteristica.vue?vue&type=script&lang=js"
import style0 from "./caracteristica.vue?vue&type=style&index=0&id=4d3077a3&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports